import React, {useEffect, useState} from 'react';
import {Button, Card, Col, Container, Row, Tab, Tabs, Table, Collapse} from 'react-bootstrap';
import { useLocation } from 'react-router-dom';
import { observer } from 'mobx-react-lite';
import { useContext } from 'react';
import { Context } from '../../index';
import {fetchComments} from "../../http/bookAPI"; // путь подкорректируй под свой
import SendMessageToReviewer from "../modals/book/SendMessageToReviewer";

const CommentsInDashboard = observer(() => {
    const [key, setKey] = useState('reviews');
    const { user } = useContext(Context);
    const [commentsToUserBooks, setCommentsToUserBooks] = useState([]);
    const [commentsToUserAssignments, setCommentsToUserAssignments] = useState([]);
    const [openRowIndex, setOpen] = useState(null);

    const [showWriteComment, setShowWriteComment] = useState(false);
    const [selectedRow, setSelectedRow] = useState(null);
    const [selectedIndex, setSelectedIndex] = useState(null);

    const openWriteComment = (row, idx) => {
        setSelectedRow(row);
        setSelectedIndex(idx);
        setShowWriteComment(true);
    };

    useEffect(() => {
        const loadData = async () => {
            try {
                const data = await fetchComments(user.user.id);
                setCommentsToUserBooks(data.commentsToUserBooks || []);
                setCommentsToUserAssignments(data.commentsToUserAssignments || []);
            } catch (e) {
                console.error("Failed to fetch comments:", e);
            }
        };

        loadData();
    }, [user.user.id]);

    const loadData = async () => {
        try {
            const data = await fetchComments(user.user.id);
            setCommentsToUserBooks(data.commentsToUserBooks || []);
            setCommentsToUserAssignments(data.commentsToUserAssignments || []);
        } catch (e) {
            console.error("Failed to fetch comments:", e);
        }
    };

    useEffect(() => {
        loadData();
    }, [user.user.id]);

    const renderRatingStars = (rating) => {
        const fullStars = Math.floor(rating || 0);

        return (
            <>
                {[...Array(5)].map((_, i) => {
                    const halfStar =
                        i === fullStars &&
                        rating % 1 >= 0.3 &&
                        rating % 1 <= 0.7;

                    const isFilled = i < fullStars;
                    const iconClass = isFilled
                        ? "bi-star-fill"
                        : halfStar
                            ? "bi-star-half"
                            : "bi-star";

                    const iconColor = isFilled || halfStar ? "gold" : "lightgray";

                    return (
                        <i
                            key={i}
                            className={`bi ${iconClass}`}
                            style={{
                                color: iconColor,
                                fontSize: "10px",
                                marginRight: "3px",
                            }}
                        />
                    );
                })}
                {' '}
                ({rating ?? "-"})
            </>
        );
    };


    return (
        <Card className="p-2 w-100 mt-2">
            <Row className="p-2">
                <Col>
                    <Tabs activeKey={key} onSelect={(k) => setKey(k)} className="mb-3 nav-success">
                        <Tab eventKey="reviews" title="Comments about Your Books">
                            <h5 className="text-muted">Reviews and Comments about Your Books</h5>
                            <div className="text-muted small mb-3">
                                <p className="mb-2">
                                    This section displays comments written by reviewers about your books.
                                    You can see the review title, the overall rating, and whether the reviewer provided an explanation for not giving 5 stars.
                                    Please note that the rating on Virtalibry may differ from the rating the reviewer left on Amazon.
                                </p>
                                <p className="mb-2">
                                    Click on any row to expand and view the full review text, the reviewer’s explanation (if available), the date and country of the review, and your internal comment if you’ve left one.

                                    A ✓ means the reviewer left a reason for not rating 5 stars; a × means they did not. The same applies to your comments on the review.
                                </p>
                            </div>


                            {commentsToUserBooks.length > 0 ? (
                                <Table bordered hover responsive size="sm">
                                    <thead className="small">
                                    <tr style={{ whiteSpace: 'nowrap' }}>
                                        <th className="text-muted small">#</th>
                                        <th className="text-muted small">Book</th>
                                        <th className="text-muted small text-center">Finalized On</th>
                                        <th className="text-muted small">Reviewer</th>
                                        <th className="text-muted small text-center">Virt Rating</th>
                                        <th className="text-muted small text-center">Amz Rating</th>
                                        <th className="text-muted small">Review Title</th>
                                        <th className="text-muted small text-center">&lt;5 Reason</th>
                                        <th className="text-muted small text-center">Quality</th>
                                        <th className="text-muted small text-center">Your Reply</th>


                                    </tr>
                                    </thead>
                                    <tbody className="small">
                                    {commentsToUserBooks.map((r, i) => (
                                        <React.Fragment key={i}>
                                            <tr
                                                className={`text-muted small ${i % 2 === 0 ? 'table-secondary' : ''}`}
                                                onClick={() => setOpen(i === openRowIndex ? null : i)}
                                                style={{
                                                    cursor: 'pointer',
                                                    whiteSpace: 'nowrap',
                                                    paddingTop: '2px',
                                                    paddingBottom: '2px',
                                                    lineHeight: '1.2',
                                                }}
                                            >
                                                <td>{i + 1}</td>
                                                <td title={r.book?.title}>
                                                    {r.book?.title?.length > 20
                                                        ? r.book.title.slice(0, 20) + '..'
                                                        : r.book?.title}
                                                </td>
                                                <td className="text-center">
                                                    {new Date(r.end_rev_date*60000).toLocaleDateString('en-GB', {
                                                        day: '2-digit',
                                                        month: 'short',
                                                        year: 'numeric'
                                                    }).replace(/ /g, '-')}
                                                </td>
                                                <td title={r.reviewer_name}>
                                                    {r.reviewer_name?.length > 10
                                                        ? r.reviewer_name.slice(0, 10) + '..'
                                                        : r.reviewer_name || '—'}
                                                </td>
                                                <td className="text-center fst-italic">
                                                    {renderRatingStars(r.rating)}
                                                </td>
                                                <td className="text-center fst-italic">
                                                    {renderRatingStars(r.checked_review_rating)}
                                                </td>
                                                <td title={r.checked_review_title}>
                                                    {r.checked_review_title?.length > 25
                                                        ? r.checked_review_title.slice(0, 25) + '..'
                                                        : r.checked_review_title || '—'}
                                                </td>

                                                <td className="text-center">
                                                    {r.why_not_5_text && r.why_not_5_text.trim() !== ""
                                                        ? <span className="text-success fw-bold">✓</span>
                                                        : <span className="text-danger fw-bold">×</span>}
                                                </td>
                                                <td className="text-center fst-italic">
                                                    {r.rating_of_reviewer && Number(r.rating_of_reviewer) !== 0
                                                        ? `${r.rating_of_reviewer} %`
                                                        : 'Not set'}

                                                </td>
                                                <td className="text-center">
                                                    {r.comment_to_review && r.comment_to_review.trim() !== ""
                                                        ? <span className="text-success fw-bold">✓</span>
                                                        : <span className="text-danger fw-bold">×</span>}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="10" className="p-0">
                                                    <Collapse in={i === openRowIndex}>
                                                        <div className="p-1 bg-light small">
                                                            <Table bordered size="sm" className="mb-0">
                                                                <thead>
                                                                <tr className="text-muted text-center" style={{ height: '20px' }}>
                                                                    <th className="text-muted small" style={{ width: '12%' }}>AMZ Info</th>
                                                                    <th className="text-muted small" style={{ width: '48%' }}>Review Text</th>
                                                                    <th className="text-muted small" style={{ width: '20%' }}>Why Not 5 (Reviewer Comment)</th>
                                                                    <th className="text-muted small" style={{ width: '20%' }}>Your Comment</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                <tr>
                                                                    <td className="text-center align-middle">
                                                                        {(r.checked_review_date || '—') +
                                                                            (r.checked_review_country ? ` · ${r.checked_review_country}` : '')}
                                                                    </td>
                                                                    <td>{r.checked_review_text || '—'}</td>
                                                                    <td className="text-center align-middle">{r.why_not_5_text || "Reviewer didn't leave a comment"}</td>
                                                                    <td className="align-middle">
                                                                        <div className="d-flex flex-column align-items-center justify-content-center text-center">
                                                                            <div className="mb-2">
                                                                                {r.comment_to_review || "You didn't leave a comment"}
                                                                            </div>

                                                                            <Button
                                                                                variant={r.comment_to_review ? "outline-secondary" : "outline-success"}
                                                                                size="sm"
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    openWriteComment(r, i);
                                                                                }}
                                                                                className="d-inline-flex btn btn-sm align-items-center"
                                                                            >
                                                                                <i className="bi bi-pencil-square me-2"></i>
                                                                                {r.comment_to_review ? "Edit Comment" : "Write Comment"}
                                                                            </Button>
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </Collapse>

                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <p className="text-muted">No reviews yet.</p>
                            )}
                        </Tab>



                        <Tab eventKey="assignments" title="Comments about Your Reviews">
                            <h5 className="text-muted">Feedback on Your Reviews</h5>
                            <div className="text-muted small mb-3">
                                <p className="mb-2">
                                    This section shows comments received on your reviews — including the original Amazon review text,
                                    feedback from publishers (if provided), and an internal quality score.    A ✓ means the publisher left a comment or rating; a × means they did not.
                                </p>
                                <p className="mb-2">
                                    Click on any row to expand and view your full review text, the publisher’s comment (if available), the date and country of your review,
                                    and whether you were rated as a high-quality reviewer.
                                </p>
                            </div>

                            {commentsToUserAssignments.length > 0 ? (
                                <Table bordered hover responsive size="sm">
                                    <thead className="small">
                                    <tr style={{ whiteSpace: 'nowrap' }}>
                                        <th className="text-muted small">#</th>
                                        <th className="text-muted small">Book</th>
                                        <th className="text-muted small">Author</th>
                                        <th className="text-muted small text-center">Finalized On</th>
                                        <th className="text-muted small text-center">Virt Rating</th>
                                        <th className="text-muted small text-center">Amz Rating</th>
                                        <th className="text-muted small">Review Title</th>
                                        <th className="text-muted small text-center">&lt;5 Reason</th>
                                        <th className="text-muted small text-center">Quality</th>
                                        <th className="text-muted small text-center">Publisher Reply</th>
                                    </tr>
                                    </thead>
                                    <tbody className="small">
                                    {commentsToUserAssignments.map((r, i) => (
                                        <React.Fragment key={i}>
                                            <tr
                                                className={`text-muted small ${i % 2 === 0 ? 'table-secondary' : ''}`}
                                                onClick={() => setOpen(i === openRowIndex ? null : i)}
                                                style={{
                                                    cursor: 'pointer',
                                                    whiteSpace: 'nowrap',
                                                    paddingTop: '2px',
                                                    paddingBottom: '2px',
                                                    lineHeight: '1.2',
                                                }}
                                            >
                                                <td>{i + 1}</td>
                                                <td title={r.book?.title}>
                                                    {r.book?.title?.length > 20
                                                        ? r.book.title.slice(0, 20) + '...'
                                                        : r.book?.title}
                                                </td>
                                                <td title={r?.book?.author}>
                                                    {r?.book?.author.length > 10
                                                        ? r?.book?.author.slice(0, 10) + '...'
                                                        : r?.book?.author || '—'}
                                                </td>
                                                <td className="text-center">
                                                    {new Date(r.end_rev_date*60000).toLocaleDateString('en-GB', {
                                                        day: '2-digit',
                                                        month: 'short',
                                                        year: 'numeric'
                                                    }).replace(/ /g, '-')}
                                                </td>

                                                <td className="text-center fst-italic">
                                                    {renderRatingStars(r.rating)}
                                                </td>
                                                <td className="text-center fst-italic">
                                                    {renderRatingStars(r.checked_review_rating)}
                                                </td>
                                                <td title={r.checked_review_title}>
                                                    {r.checked_review_title?.length > 25
                                                        ? r.checked_review_title.slice(0, 25) + '...'
                                                        : r.checked_review_title || '—'}
                                                </td>
                                                <td className="text-center">
                                                    {r.why_not_5_text && r.why_not_5_text.trim() !== ""
                                                        ? <span className="text-success fw-bold">✓</span>
                                                        : <span className="text-danger fw-bold">×</span>}
                                                </td>
                                                <td className="text-center fst-italic">
                                                    {renderRatingStars(r.rating_of_reviewer)}
                                                </td>
                                                <td className="text-center">
                                                    {r.message_to_publisher && r.message_to_publisher.trim() !== ""
                                                        ? <span className="text-success fw-bold">✓</span>
                                                        : <span className="text-danger fw-bold">×</span>}
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="10" className="p-0">
                                                    <Collapse in={i === openRowIndex}>
                                                        <div className="p-1 bg-light small">
                                                            <Table bordered size="sm" className="mb-0">
                                                                <thead>
                                                                <tr className="text-muted text-center" style={{ height: '20px' }}>
                                                                    <th className="text-muted small" style={{ width: '15%' }}>AMZ Info</th>
                                                                    <th className="text-muted small" style={{ width: '55%' }}>Your Review Text</th>
                                                                    <th className="text-muted small" style={{ width: '30%' }}>Publisher's Comment</th>
                                                                </tr>
                                                                </thead>
                                                                <tbody>
                                                                <tr>
                                                                    <td className="text-center align-middle">
                                                                        {(r.checked_review_date || '—') +
                                                                            (r.checked_review_country ? ` · ${r.checked_review_country}` : '')}
                                                                    </td>
                                                                    <td>{r.checked_review_text || '—'}</td>
                                                                    <td className="text-center align-middle">{r.message_to_publisher || "Publisher didn't leave a comment"}</td>
                                                                </tr>
                                                                </tbody>
                                                            </Table>
                                                        </div>
                                                    </Collapse>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                    </tbody>
                                </Table>
                            ) : (
                                <p className="text-muted">No feedback received yet.</p>
                            )}
                        </Tab>

                    </Tabs>
                </Col>
            </Row>
            <SendMessageToReviewer
                show={showWriteComment}
                onClose={() => setShowWriteComment(false)}
                assign={{
                    ...selectedRow,
                    id: selectedRow?.id ?? selectedRow?.id,
                }}
                onUpdateAssign={async (updatedFields) => {
                    // локально обновим состояние таблицы
                    setCommentsToUserBooks((prev) =>
                        prev.map((row, idx) =>
                            idx === selectedIndex ? { ...row, ...updatedFields } : row
                        )
                    );

                    // и дополнительно подтянем актуальные данные с сервера
                    await loadData();
                }}
            />
        </Card>
    );
});

export default CommentsInDashboard;
